import { formRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';
import store from '@/store';
import getPayload from '@/forms/helpers/get-payload';

import {
  SET_APP_ID,
} from '@/lib/constants/mutations';

export default {
  setCustomerNameByCifNumber: async (step, callbacks, cifField, fullNameField) => {
    const { form } = step;
    const response = await callApi({
      form,
      callbacks,
      formElement: step,
      apiCall: formRepository.getFormByCif,
      payload: form.getField(cifField).value,
    });

    if (response) {
      const customerName = response.data['full-name'];
      const field = form.getField(fullNameField);
      field.onInstantChange(customerName);
    }

    return response;
  },

  sendFormData: async (step, callbacks) => {
    const { form } = step;
    const payload = getPayload();
    let response = false;

    response = await callApi({
      callbacks,
      form,
      formElement: step,
      apiCall: formRepository.formSubmission,
      payload,
    });
    if (response) {
      const appId = response['app-detail']['app-id'];
      if (appId) {
        store.commit(SET_APP_ID, { appId });
      }
    }

    return !!response;
  },

  sendFormWithoutBlock: async () => {
    const response = await formRepository.formSubmission(getPayload());
    if (response) {
      const appId = response.data['app-detail']['app-id'];
      if (appId) {
        store.commit(SET_APP_ID, { appId });
      }
    }
  },
};
